
<div class="sections">
  <div class="section">
    <div class="loading" *ngIf="loadingFlatsInfo; else loaded"></div>
    <ng-template #loaded>
      <div class="toogle-tables">
        <table>
          <thead>
            <tr>
              <th colspan="1"></th>
              <th colspan="2" class="gray">Всего</th>
              <th colspan="3">Реализовано</th>
              <th colspan="2" class="gray">Остаток</th>
              <th colspan="1">Доход от продажи</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Квартиры</td>
              <td class="gray">Ед.</td>
              <td class="gray">Себеcтоимость</td>
              <td>Ед.</td>
              <td>Себеcтоимость</td>
              <td>Фактическая <br> стоимость реализации</td>
              <td class="gray">Ед.</td>
              <td class="gray">Себестоимость</td>
              <td></td>
            </tr>
            <ng-container *ngFor="let flat of itemsForFlatsEx;">
              <tr *ngIf="flat.totalFlatCount > 0" [class.total]="flat.roomCountID === -100">
                <td class="title">{{flat.roomCountTitle}}</td>
                <td class="gray">{{flat.totalFlatCount | numberWithSpaces}}</td>
                <td class="gray">{{flat.totalFlatAmount | numberWithSpaces: 'twoDecimals'}}</td>
                <td>{{flat.salesFlatCount | numberWithSpaces}}</td>
                <td>{{flat.salesFlatAmount1 | numberWithSpaces: 'twoDecimals'}}</td>
                <td>{{flat.salesFlatAmount2 | numberWithSpaces: 'twoDecimals'}}</td>
                <td class="gray">{{flat.residueFlatCount | numberWithSpaces}}</td>
                <td class="gray">{{flat.residueFlatAmount | numberWithSpaces: 'twoDecimals'}}</td>
                <td>{{flat.income | numberWithSpaces: 'twoDecimals'}}</td>
              </tr>
            </ng-container>
          </tbody>
          <tfoot>
            <tr *ngIf="firstFlat.totalFlatCount > 0">
              <td>{{firstFlat.roomCountTitle}}</td>
              <td class="gray">{{firstFlat.totalFlatCount | numberWithSpaces}}</td>
              <td class="gray">{{firstFlat.totalFlatAmount | numberWithSpaces: 'twoDecimals'}}</td>
              <td>{{firstFlat.salesFlatCount | numberWithSpaces}}</td>
              <td>{{firstFlat.salesFlatAmount1 | numberWithSpaces: 'twoDecimals'}}</td>
              <td>{{firstFlat.salesFlatAmount2 | numberWithSpaces: 'twoDecimals'}}</td>
              <td class="gray">{{firstFlat.residueFlatCount | numberWithSpaces}}</td>
              <td class="gray">{{firstFlat.residueFlatAmount | numberWithSpaces: 'twoDecimals'}}</td>
              <td>{{firstFlat.income | numberWithSpaces: 'twoDecimals'}}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </ng-template>  
  </div>
  <div class="section">
    <div class="section-title">
      Квартиры
    </div>
    <div class="section-inner">
      <app-flats [buildingId]="spotId" [spotObject]="spotObject" (confirmEvent)="reloadData($event)"></app-flats>
    </div>
  </div>

  <div class="section">
    <div class="section-title">
      Коммерческие помещения
    </div>
    <div class="section-inner">
      <app-commercial-rooms
        [isSalesMode]="true"
        [reloadTrigger]="reloadTrigger" 
        [buildingNumber]="spotObject.number"
        [houseNumber]="spotObject.homeNumber" 
        [buildingID]="spotObject.id" 
        [roomTypeID]="RoomTypeEnum.Commercial"
        (saleDialogEmit)="openSaleDialog($event, RoomTypeEnum.Commercial)">
      </app-commercial-rooms>
    </div>
  </div>
  <div class="section">
    <div class="section-title">
      Парковочные места
    </div>
    <div class="section-inner">
      <app-commercial-rooms
        [isSalesMode]="true"
        [reloadTrigger]="reloadTrigger"
        [buildingNumber]="spotObject.number"
        [houseNumber]="spotObject.homeNumber"
        [buildingID]="spotObject.id"
        [roomTypeID]="RoomTypeEnum.Parking"
        (saleDialogEmit)="openSaleDialog($event, RoomTypeEnum.Parking)">
      </app-commercial-rooms>
    </div>
  </div>
</div>

